import Flex from 'components/Flex';
import Checkbox from 'components/Form/Checkbox';
import Input from 'components/Form/Input';
import Text from 'components/Text';
import { Field, FormikProps } from 'formik';
import useUrlSearchParams from 'hooks/useUrlSearchParam';
import RegisterNotice from 'pages/Auth/UserSignIn/RegisterNotice';
import { Container, Footer, LargeButton } from 'pages/Auth/UserSignIn/styled';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import useTheme from 'hooks/useTheme';
import styled from 'styled-components';
import { ISignInFormValues } from './index';
import StyledErrorMessage from 'components/Form/StyledErrorMessage';
import Password from 'components/Form/Password';

const Form: FunctionComponent<FormikProps<ISignInFormValues> & { error: string }> = ({
  handleSubmit,
  setFieldValue,
  error,
}) => {
  const theme = useTheme();
  useUrlSearchParams('email', (email) => setFieldValue('email', email, false));

  return (
    <Container justifyContent="center" alignItems="center">
      <form onSubmit={handleSubmit}>
        <Title>Log in</Title>
        <Field
          name="email"
          component={Input}
          label="E-mail"
          placeholder="Your Email"
          className="mt16"
        />
        <Field
          name="password"
          type="password"
          component={Password}
          label="Password"
          placeholder="Your Password"
          className="mt16"
        />
        <Flex justifyContent="space-between" className="mt32">
          <Field
            name="remember"
            component={Checkbox}
            label="Remember me"
            type="checkbox"
            className="mr8"
          />
        </Flex>
        <Flex justifyContent="center" className="mt16">
          <LargeButton type="submit">Log in</LargeButton>
        </Flex>
        {error && <StyledErrorMessage className="mt10">{error}</StyledErrorMessage>}
        <Flex
          alignItems="center"
          justifyContent="space-between"
          className="mt22"
          direction="column"
        >
          <Text>Can’t Sign In?</Text>
          <StyledLink color={theme.colors.accentNormal} to="/forgot">
            <LargeButton styleType="primary" className="mt18">
              <Text color={theme.colors.accentNormal}>Reset Your Password</Text>
            </LargeButton>
          </StyledLink>
        </Flex>
        <Footer>
          <RegisterNotice />
        </Footer>
      </form>
    </Container>
  );
};

export default Form;

const Title = styled.h1`
  color: ${(props) => props.theme.colors.dark};
  font-family: Gotham Pro Bold;
  line-height: 64px;
  font-size: 46px;
  text-align: center;
  letter-spacing: -0.04em;
  padding-bottom: 32px;
  ${(props) => props.theme.media.md`
     padding-bottom: 0;
  `}
`;

const StyledLink = styled(Link)`
  width: 100%;
`;
